<template>
	<div>
		<div v-if="state === 'active_paused_active'" @click.stop="do_start()">
			<svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M4.26005 18.32L5.69005 16.89C4.83005 15.79 4.25005 14.46 4.07005 13H2.05005C2.25005 15.01 3.05005 16.84 4.26005 18.32Z" fill="#79EC00"/>
				<path d="M7.09993 5.69005C8.20993 4.83005 9.53993 4.25005 10.9999 4.07005V2.05005C8.98993 2.25005 7.15993 3.05005 5.67993 4.26005L7.09993 5.69005Z" fill="#79EC00"/>
				<path d="M2.05005 11.0001H4.07005C4.25005 9.54005 4.83005 8.21005 5.69005 7.10005L4.26005 5.68005C3.05005 7.16005 2.25005 8.99005 2.05005 11.0001Z" fill="#79EC00"/>
				<path d="M13.05 2.05005V4.07005C16.97 4.59005 20 7.95005 20 12C20 16.05 16.97 19.41 13.05 19.93V21.95C18.08 21.42 22 17.16 22 12C22 6.84005 18.08 2.58005 13.05 2.05005Z" fill="#79EC00"/>
				<path d="M16 12L13.05 9.79L10 7.5V16.5L13.05 14.21L16 12Z" fill="#79EC00"/>
				<path d="M5.67993 19.7401C7.15993 20.9501 8.99993 21.7501 10.9999 21.9501V19.9301C9.53993 19.7501 8.20993 19.1701 7.09993 18.3101L5.67993 19.7401Z" fill="#79EC00"/>
			</svg>
		</div>
		<div v-if="state === 'active_running'" @click.stop="do_stop()">
			<svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g id="pause_circle_outline_24px">
					<g id="Dark Color">
						<path id="Mask" d="M13 8H15V16H13V8Z" fill="black" fill-opacity="0.54"/>
					</g>
					<g id="Dark Color_2">
						<path id="Mask_2" d="M9 8H11V16H9V8Z" fill="black" fill-opacity="0.54"/>
					</g>
					<g id="Dark Color_3">
						<path id="Mask_3" fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12ZM20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12Z" fill="black" fill-opacity="0.54"/>
					</g>
				</g>
			</svg>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		recording: {
			type: Boolean,
			default: false
		},
		active: {
			type: Boolean,
			default: false
		},
		status_type: {
			type: Number,
			default: 0
		},
		width: {
			type: String,
			default: '24'
		},
		height: {
			type: String,
			default: '24'
		}
	},
	computed: {
		state() {
			let state_tmp = 'unknown';

			if (this.status_type === 2) {
				if (this.recording) {
					state_tmp = 'active_running';
				}
				if (this.active) {
					state_tmp = 'active_paused_active';
				}
			}

			return state_tmp;
		}
	},
	methods: {
		do_start() {
			this.$emit('start');
		},
		do_stop() {
			this.$emit('stop');
		}
	}
}
</script>

